import { __decorate } from 'tslib';
import { Injectable, NgModule } from '@angular/core';
import { ApiService, UiBsOauthModule } from '@wlp/ui-bs-oauth';
import { of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

const SPE_N_PRE_PIX_PROXY = '/spe-n-pre-pix';
let SpeNPrePixProxy = class SpeNPrePixProxy {
    constructor(api) {
        this.api = api;
    }
    registerKey(uuidAccountPayment, keyType, key, validationToken) {
        const uri = `${SPE_N_PRE_PIX_PROXY}/v1/registry-key/`;
        const body = {
            uuidAccountPayment,
            keyType,
            key,
            validationToken
        };
        return this.api.post(uri, body).pipe(map((result) => {
            return result;
        }), catchError((err) => {
            return of(err);
        }));
    }
    updateKey(uuidAccountPayment, keyType, key) {
        const uri = `${SPE_N_PRE_PIX_PROXY}/v1/registry-key/`;
        let prepix;
        const body = {
            uuidAccountPayment,
            keyType,
            key,
        };
        return this.api.put(uri, body).pipe(map((result) => {
            if (result !== null && result !== undefined) {
                prepix = {
                    message: 'Chave atualizado com sucesso!',
                    data: result,
                };
                return prepix;
            }
            throw new Error('Houve um erro ao salvar os dados!');
        }), catchError((err) => {
            prepix = {
                message: err,
                data: null,
            };
            return of(prepix);
        }));
    }
    deleteKey(uuidAccountPayment, uuid) {
        const uri = `${SPE_N_PRE_PIX_PROXY}/v1/registry-key/?uuidAccountPayment=${uuidAccountPayment}&uuid=${uuid}`;
        let prepix;
        return this.api.delete(uri, uuidAccountPayment).pipe(map((result) => {
            return result;
        }), catchError((err) => {
            return of(err);
        }));
    }
    getAllKey(uuidAccountPayment) {
        const uri = `${SPE_N_PRE_PIX_PROXY}/v1/registry-key/by-account/${uuidAccountPayment}`;
        let prepix;
        return this.api.get(uri).pipe(map((result) => {
            if (result !== null && result !== undefined) {
                prepix = {
                    message: 'Chaves cadastradas!',
                    data: result,
                };
                return prepix;
            }
            throw new Error('Houve um erro ao salvar os dados!');
        }), catchError((err) => {
            prepix = {
                message: err,
                data: null,
            };
            return of(prepix);
        }));
    }
    getAllKeyByAccountActive(uuidAccountPayment) {
        const uri = `${SPE_N_PRE_PIX_PROXY}/v1/registry-key/by-account-active/${uuidAccountPayment}`;
        let prepix;
        return this.api.get(uri).pipe(map((result) => {
            return result;
        }), catchError((err) => {
            return of(err);
        }));
    }
    createClaims(createRequest) {
        const uri = `${SPE_N_PRE_PIX_PROXY}/v1/claims/create`;
        return this.api.post(uri, createRequest);
    }
    confirmClaims(claimRequest, uuidAccountPayment) {
        const uri = `${SPE_N_PRE_PIX_PROXY}/v1/claims/confirm`;
        return this.api.post(uri, claimRequest, uuidAccountPayment);
    }
    cancelClaims(claimRequest, uuidAccountPayment) {
        const uri = `${SPE_N_PRE_PIX_PROXY}/v1/claims/cancel`;
        return this.api.post(uri, claimRequest, uuidAccountPayment);
    }
    generateEncodeKey(body) {
        const uri = `${SPE_N_PRE_PIX_PROXY}/v1/encode-key/`;
        return this.api.post(uri, body);
    }
    createCodeClaimValidation(body) {
        const uri = `${SPE_N_PRE_PIX_PROXY}/v1/claims/claim-code/create`;
        return this.api.post(uri, body);
    }
    validationClaimCode(body) {
        const uri = `${SPE_N_PRE_PIX_PROXY}/v1/claims/claim-code/validation`;
        return this.api.post(uri, body);
    }
};
SpeNPrePixProxy.ctorParameters = () => [
    { type: ApiService }
];
SpeNPrePixProxy = __decorate([
    Injectable()
], SpeNPrePixProxy);

const SPE_VIEW_N_PRE_PIX_PROXY = '/spe-view-n-pre-pix';
let SpeViewNPrePixProxy = class SpeViewNPrePixProxy {
    constructor(api) {
        this.api = api;
    }
    getClaimsPayshop(uuidAccountPayment) {
        const uri = `${SPE_VIEW_N_PRE_PIX_PROXY}/v1/claims/by-account/${uuidAccountPayment}`;
        return this.api.get(uri).pipe(map((result) => {
            if (result !== null && result !== undefined) {
            }
            throw 'Houve um erro ao buscar os dados!';
        }), catchError((err) => {
            return of(err);
        }));
    }
    getClaims(uuidAccountPayment) {
        const uri = `${SPE_VIEW_N_PRE_PIX_PROXY}/v1/claims/topazio/${uuidAccountPayment}`;
        return this.api.get(uri).pipe(map((result) => {
            if (result !== null && result !== undefined) {
            }
            throw 'Houve um erro ao buscar os dados!';
        }), catchError((err) => {
            return of(err);
        }));
    }
};
SpeViewNPrePixProxy.ctorParameters = () => [
    { type: ApiService }
];
SpeViewNPrePixProxy = __decorate([
    Injectable()
], SpeViewNPrePixProxy);

const SPE_VIEW_N_PIX_PROXY = '/spe-view-n-pix';
let SpeViewNPixProxy = class SpeViewNPixProxy {
    constructor(api) {
        this.api = api;
    }
    decodePixKey(key, keyType) {
        const uri = `${SPE_VIEW_N_PIX_PROXY}/v1/decode/key/${key}/type/${keyType}`;
        return this.api.get(uri);
    }
    decodePixQrCode(emv) {
        const uri = `${SPE_VIEW_N_PIX_PROXY}/v1/decode/qr-code?emv=${encodeURIComponent(emv)}`;
        return this.api.get(uri);
    }
};
SpeViewNPixProxy.ctorParameters = () => [
    { type: ApiService }
];
SpeViewNPixProxy = __decorate([
    Injectable()
], SpeViewNPixProxy);

let UiPxPixModule = class UiPxPixModule {
};
UiPxPixModule = __decorate([
    NgModule({
        declarations: [],
        imports: [UiBsOauthModule],
        providers: [SpeNPrePixProxy, SpeViewNPrePixProxy, SpeViewNPixProxy],
    })
], UiPxPixModule);

class PrePixKeys {
}

/*
 * Public API Surface of ui-px-pre-pix
 */

/**
 * Generated bundle index. Do not edit.
 */

export { PrePixKeys, SpeNPrePixProxy, SpeViewNPixProxy, SpeViewNPrePixProxy, UiPxPixModule };
//# sourceMappingURL=wlp-ui-px-pix.js.map
